import { ComponentProps, FC } from "react";

import { cn } from "@/lib/utils/cn";

const MainContentContainer: FC<ComponentProps<"main">> = ({
  className,
  ...props
}) => {
  return (
    <main
      {...props}
      id="main-content-container"
      className={cn(
        "w-full flex flex-1 justify-center overflow-x-auto",
        className
      )}
    >
      <div className="w-full max-w-[1500px]">{props.children}</div>
    </main>
  );
};

export default MainContentContainer;
